module.exports = __webpack_public_path__ + "static/media/javascript-operators-functions-null-and-undefined-tips.f5ba88bc.jpg";